import classnames from "classnames";
import { get } from "lodash";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import Input from "shared/components/Input";
import Label from "shared/components/Label";
import Select from "shared/components/Select";
import { LOCAL_PHONE_MAX_LENGTH } from "utils/helpers/phone";

const PhoneWithPrefix = ({
  label,
  icon,
  placeholder,
  prefixOptions,
  prefixValue,
  value,
  onChange,
  onBlur,
  onPrefixChange,
  errors,
  touched,
  required,
  optional,
  disabled,
  stripSpaces = true,
}) => {
  const defaultPrefix = get(prefixOptions, "[0].value", "+33");
  const [selectedPrefix, setSelectedPrefix] = useState(
    prefixValue || defaultPrefix,
  );
  const [localNumber, setLocalNumber] = useState(value || "");
  const hasError = touched && errors;

  useEffect(() => {
    setSelectedPrefix(prefixValue || defaultPrefix);
  }, [prefixValue, defaultPrefix]);

  useEffect(() => {
    setLocalNumber(value || "");
  }, [value]);

  const handlePrefixChange = (prefix) => {
    setSelectedPrefix(prefix);
    onPrefixChange(prefix);
  };

  const handleLocalChange = ({ target: { value: nextValue } }) => {
    const normalized = stripSpaces ? nextValue.replace(/\s/g, "") : nextValue;
    setLocalNumber(normalized);
    onChange(normalized);
  };

  return (
    <div
      className={classnames("phone-with-prefix", {
        "phone-with-prefix--error": hasError,
      })}
    >
      <Label
        label={label}
        icon={icon}
        required={required}
        optional={optional}
      />
      <div className="phone-with-prefix__fields">
        <div className="phone-with-prefix__prefix">
          <Select
            options={prefixOptions}
            value={selectedPrefix}
            optionLabelProp="value"
            popupMatchSelectWidth={false}
            dropdownStyle={{ minWidth: 220 }}
            onChange={handlePrefixChange}
            onBlur={onBlur}
            disabled={disabled}
          />
        </div>
        <div className="phone-with-prefix__number">
          <Input
            placeholder={placeholder}
            type="custom"
            stripSpaces={stripSpaces}
            inputMode="numeric"
            maxLength={LOCAL_PHONE_MAX_LENGTH}
            value={localNumber}
            onChange={handleLocalChange}
            onBlur={onBlur}
            disabled={disabled}
          />
        </div>
      </div>
      {hasError && <p className="input--errors">{errors}</p>}
    </div>
  );
};

PhoneWithPrefix.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.node,
  placeholder: PropTypes.string,
  prefixOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  prefixValue: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  onPrefixChange: PropTypes.func.isRequired,
  errors: PropTypes.string,
  touched: PropTypes.bool,
  required: PropTypes.bool,
  optional: PropTypes.string,
  disabled: PropTypes.bool,
  stripSpaces: PropTypes.bool,
};

PhoneWithPrefix.defaultProps = {
  label: "",
  placeholder: "",
  prefixValue: "",
  value: "",
  errors: "",
  touched: false,
  required: false,
  disabled: false,
  stripSpaces: true,
};

export default PhoneWithPrefix;
